export default __webpack_public_path__ + "static/media/SI.d274261f.ico";